import { gql } from '@apollo/client';
const getInvite = gql `
  query GetInvite($documentId: String!) {
    externalSharingInvites(where: { fileSystemDocumentId: { eq: $documentId } }) {
      id
      createdAt
      documentId: fileSystemDocumentId
      inviter {
        id
        name
      }

      invitee {
        id
        name
      }

      messageThreads {
        unreadMessagesCount
        interlocutor {
          id
          name
        }

        messages {
          id
          createdAt
          message
          isRead
          sender {
            id
            name
          }
        }
      }
    }
  }
`;
export default getInvite;
